<template>
  <div>


    <!-- main container -->
    <div
      class="main-container"
    >


      <div
        class="sub-container"
      >

        <!-- top -->
        <div
          class="top"
        >
          <div
            class="top-container"
          >

            <!-- logo -->
            <div
              class="logo"
            >

              <div
                class="logo-container"
              >
                <!--img src="statics/images/IdeezaLogo.png"/-->

                <div class="viewzzz-container">
                  <div class="view">view<span class="viewzzz-main-z">Z</span>zz</div>
                </div>

              </div>
            </div>
            <!-- /logo -->

          </div>
        </div>
        <!-- /top -->





        <!-- middle -->
        <div
          class="middle"
        >

          <div
            class="middle-container"
          >


            <!-- messages -->
            <div
              class="messages"
            >


              <!-- message container -->
              <div
                class="message-container"
              >


                <!-- imp message -->
                <div
                  class="imp-message"
                >

                  <div
                    class="text-head"
                  >
                    Sorry this site is undergoing some Changes
                  </div>
                </div>
                <!-- /imp message -->



                <!-- message -->
                <div
                  class="message"
                >

                  <div
                    class="text-sub-head"
                  >
                    Please check with us again soon!
                  </div>
                </div>
                <!-- /message -->

              </div>
              <!-- /message container -->
            </div>
            <!-- /messages -->

          </div>
        </div>
        <!-- /middle -->




        <!-- bottom image -->
        <div
          class="bottom"
        >

          <div
            class="bottom-container"
          >

            <!--img src="../statics/images/BarrierIcon.png"/-->
          </div>
        </div>
        <!-- /bottom image -->



        <!-- social -->
        <div
          class="social-main-container"
        >

          <div
            class="bottom-sub-container"
          >

            <!--img @click="goToSocialLink('in')" src="statics/social/in.png"/>
            <img @click="goToSocialLink('twitter')" src="statics/social/twitter.png"/>
            <img @click="goToSocialLink('insta')" src="statics/social/insta.png"/>
            <img @click="goToSocialLink('fb')" src="statics/social/fb.png"/-->
          </div>
        </div>
        <!-- /social -->

      </div>

    </div>
    <!-- /main container -->

  </div>
</template>

<style
  scoped
  lang="scss"
>
  $primary: #bdc3c7; //#ff00c7;
  $secondary: #2c3e50; //#441184;



  @font-face {
    font-family: Atma-Medium;
    src: url("/static/font/Atma-Medium.ttf");
  }

  // main container
  .main-container {
    height: 100vh;
    width: 100vw;
    overflow: hidden;

    .sub-container {
      background: linear-gradient(45deg,$primary,$secondary);
      padding: 20px;
      box-shadow: inset 0px 0px 40px rgba(0, 0, 0, 0.5);



      // top
      .top {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        height: 20vh;
        //background: green;

        .top-container {


          // logo
          .logo {
            display: flex;
            justify-content: center;
            //

            .logo-container {
              margin-top: 10vh;

              /*img {
              height: 5em;
              }*/

              .viewzzz-container {
                height: 20vh;
                display: flex;
                align-items: center;
                justify-content: center;


                .view {
                  font-family: Atma-Medium;
                  font-style: normal;
                  font-size: 3.714em;
                  color: black;
                  letter-spacing: 0;
                }

                .viewzzz-main-z {
                  font-family: Atma-Medium;
                  font-weight: 600;
                }
              }

            }
          }
          // /logo
        }
      }
      // /top


      // middle
      .middle {
        height: 60vh;
        //background: green;
        display: flex;
        align-items: center;
        justify-content: center;

        .middle-container {


          // message
          .messages {
            display: flex;
            justify-content: center;
            //
            padding-left: 2em;
            padding-right: 2em;

            .message-container {

              .imp-message {

                .text-head {
                  text-align: center;
                  color: #f0f0f0;
                  font-weight: 600;
                  font-size: 2.2em;
                  letter-spacing: 1px;
                }
              }

              .message {
                //
                display: flex;
                justify-content: center;
                //
                margin-top: 6px;
                //
                .text-sub-head {
                  text-align: center;
                  color: #e9e9e9;
                  font-weight: 400;
                  font-size: 2.2em;
                  letter-spacing: 1px;
                }
              }
            }
          }
          // /message
        }
      }
      // /middle



      // bottom
      .bottom {
        height: 20vh;
        //background: yellow;


        // social
        // /social

        .bottom-container {
          display: flex;
          justify-content: center;
          //

          img {
            //
            position: fixed;
            bottom: 0;
            height: 30vh;
          }
        }
      }
      // /bottom



      // social
      .social-main-container {
        display: flex;
        justify-content: space-around;
        background: blue;

        .bottom-sub-container {
          position: fixed;
          bottom: 10.5vh;

          img {
            height: 2vh;
            margin-left: 0.2em;
            margin-right: 0.2em;
            cursor: pointer;
          }
        }
      }
      // /social

    }
  }
  // /main container
</style>

<script>
  export default {
    name: 'PageIndex',
    methods: {
      goToSocialLink (social) {

        switch (social) {
          case 'fb': window.open('https://www.facebook.com/pages/category/Software-Company/Ideeza-222844688569339/')
            break
          case 'insta': window.open('https://www.instagram.com/p/Bl7BbpFnhBZ/?tagged=ideeza')
            break
          case 'twitter': window.open('https://twitter.com/IDEEZA2')
            break
          case 'in': window.open('https://www.linkedin.com/company/ideeza1826/')
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// maintainer.vue?2ba2890f